import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_protected/data')({
  component: lazyRouteComponent(() => import('@/pages/data-catalog'), 'DataCatalogPage'),
})

